<template>
  <div :class="`table-cell ${customClasses || ''}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TableCell',
  props: [
    'customClasses'
  ]
}
</script>
